import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/frontdoor/login.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']  // Note: Changed to "styleUrls" (plural) if needed
})
export class SignupComponent {
  username = '';
  email = '';
  password = '';
  firstname = '';
  lastname = '';
  phoneNumber = '';
  address = '';
  city = '';
  state = '';
  country = '';
  department = '';
  title = '';
  showPassword = false;
  passwordError = '';
  selectedFile: File | null = null;

  constructor(private loginService: LoginService, private router: Router) {}

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  // Check password strength: at least 8 chars, 1 uppercase, 1 digit.
  checkPasswordStrength(password: string) {
    const regex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!regex.test(password)) {
      this.passwordError = 'Password must have at least 8 characters, 1 uppercase, and 1 digit.';
    } else {
      this.passwordError = '';
    }
  }

  // Capture the selected file from the file input.
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  onSignup() {
    this.checkPasswordStrength(this.password);
    if (this.passwordError) {
      alert(this.passwordError);
      return;
    }
    if (!this.selectedFile) {
      alert('Please select an image.');
      return;
    }

    // Build the FormData with all fields and the file.
    const formData = new FormData();
    formData.append('username', this.username);
    formData.append('email', this.email);
    formData.append('password', this.password);
    formData.append('firstname', this.firstname);
    formData.append('lastname', this.lastname);
    formData.append('phoneNumber', this.phoneNumber);
    formData.append('address', this.address);
    formData.append('city', this.city);
    formData.append('state', this.state);
    formData.append('country', this.country);
    formData.append('department', this.department);
    formData.append('title', this.title);
    formData.append('image', this.selectedFile);

    this.loginService.signup(formData).subscribe(
      res => {
        if (res.success) {
          alert('Signup successful! You can now login.');
          this.router.navigate(['/login']);
        } else {
          alert(res.message);
        }
      },
      err => {
        console.error(err);
        alert('Server error');
      }
    );
  }
}
